<template>
    <div>
        <div ref="modal" 
            class="modal fade" 
            data-bs-backdrop="static" 
            tabindex="-1" 
            aria-labelledby="erkModalLabel" 
            aria-modal="true" 
            role="dialog" 
            style="padding-right: 17px;">
            <div class="modal-dialog modal-dialog-scrollable modal-lg">
                <div class="modal-content">
                    <div class="modal-header py-2 pe-2">
                        <strong class="modal-title">{{path.name}}</strong>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div v-if="isLoading" class="message">
                            Caricamento...
                        </div>
                        <div v-else>
                            <div v-if="!contents || contents.length == 0" class="message">
                                Nessun contenuto trovato
                            </div>
                            <div v-else>
                                <div 
                                    v-for="(content, ck) in contents" :key="ck"
                                    class="'erk-row-hover row mb-3 mb-lg-5 p-lg-2 pb-3 px-2">

                                    <!-- Colonna sinistra - immagine -->
                                    <div class="col-3 col-lg-2 px-0 cursor-pointer"
                                        @click="onClickPlayContent(content)">
                                        <img :src="content.thumbnail" class="img-fluid" alt="Copertina materiale">
                                    </div>
                                    <!-- /Colonna sinistra - immagine -->

                                    <!-- Colonna destra - dati -->
                                    <div class="col-9 col-lg-10">
                                        <div class="row h-100">
                                            <div>
                                                <div class="row align-items-start">
                                                    <div>
                                                        <h5 class="mb-1">{{content.name}}</h5><!-- Titolo -->
                                                        <span class="d-block"><em><small>{{content.authors}}</small></em></span><!-- Autori -->
                                                        <p class="mt-1"><strong>{{content.goal}}</strong></p><!-- Descrizione -->
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- CTA -->
                                            <div class="pe-0">
                                                <div class="row h-100 align-items-end">
                                                    <div class="erk-hover-toggle">
                                                        <div class="text-end">
                                                            <a 
                                                                v-if="path.pa_type == 'private'"
                                                                @click="onClickAddToPath(content)" 
                                                                class="btn btn-light">
                                                                <span class="bi bi-check2-circle"></span>
                                                                <span class="d-none d-lg-inline-block">Rimuovi</span>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- /CTA -->
                                        </div>
                                    </div>
                                    <!-- /Colonna destra - dati -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <!-- CTA -->
                        <button type="button" class="btn btn-primary close-btn" data-bs-toggle="modal" data-bs-dismiss="modal">
                            <span class="bi-check2-circle"></span>
                            Chiudi
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios"
let contentWindow = null

export default{
    props: {
    },
    data(){
        return {
            path: {},
            isLoading: false,
            contents: [],
            userId: 0,
            sessionId: 0
        }
    },
    mounted(){
        
    },
    methods: {
        open(path, userId, sessionId){
            this.path = path
            var modal = new window.bootstrap.Modal( this.$refs.modal )
            modal.toggle()  

            this.userId = userId
            this.sessionId = sessionId

            this.loadContents()
        },
        loadContents(){
            this.isLoading = true

            axios.post('/structure/content/ContentPathAction-findAllForContent', {
                contentId: this.path.content_id
            })
                .then((response) => {
                    this.isLoading = false
                    if (response.data.hasErrors){
                        alert(response.data.errors)
                        return
                    }

                    this.contents = response.data.data
                })
                .catch((error) => {
                    this.isLoading = false
                    alert(error)
                })
        },
        onClickPlayContent(content){
            if (contentWindow !== null && !contentWindow.closed) {
                contentWindow.close();
            }

            var height = screen.height - 100;
            var width = screen.width - 20;
                        
            contentWindow = window.open("/structure/ContentPlayAction?traking=0&contentId=" + content.content_id + 
                "&component=0", 
                "", 
                "top=0, left=0, width=" + width + ", height=" + height + ", status=no, menubar=no, toolbar=no scrollbars=no");
        },
    }
}
</script>
